
import Previewer from 'vux/src/components/previewer/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'


export default {
name: 'step5',
directives: {
TransferDom
},
components: {
Previewer
},
data () {
return {
list: [
{
msrc: 'https://mylink.oss-accelerate.aliyuncs.com/5gact/greenchannel/%E5%81%A5%E5%BA%B7%E9%A9%9B%E7%AB%99%E6%88%BF%E9%96%93%E7%B7%9A%E4%B8%8A%E9%A0%90%E7%B4%84%E7%B3%BB%E7%B5%B1%402x.png',
src: 'https://mylink.oss-accelerate.aliyuncs.com/5gact/greenchannel/%E5%81%A5%E5%BA%B7%E9%A9%9B%E7%AB%99%E6%88%BF%E9%96%93%E7%B7%9A%E4%B8%8A%E9%A0%90%E7%B4%84%E7%B3%BB%E7%B5%B1%402x.png',
w: 600,
h: 400
},
{
msrc: 'https://mylink.oss-accelerate.aliyuncs.com/5gact/greenchannel/%E9%A0%90%E7%B4%84%E7%A2%BA%E8%AA%8D%E5%96%AE%E5%8F%8A%E4%BA%8C%E7%B6%AD%E7%A2%BC%402x.png',
src: 'https://mylink.oss-accelerate.aliyuncs.com/5gact/greenchannel/%E9%A0%90%E7%B4%84%E7%A2%BA%E8%AA%8D%E5%96%AE%E5%8F%8A%E4%BA%8C%E7%B6%AD%E7%A2%BC%402x.png',
w: 600,
h: 400
}
],
options: {
getThumbBoundsFn (index) {

let thumbnail = document.querySelectorAll('.previewer-demo-img')[index]

let pageYScroll = window.pageYOffset || document.documentElement.scrollTop


let rect = thumbnail.getBoundingClientRect()

return { x: rect.left, y: rect.top + pageYScroll, w: rect.width }
}
}
}
},
methods: {
logIndexChange (arg) {
console.log(arg)
},
show (index) {
this.$refs.previewer.show(index)
}
}
}



// WEBPACK FOOTER //
// ./src/page/greenchannel/component/step2.vue